"use client";
import { useRouter, useSearchParams } from "next/navigation";
import { Pagination } from "@packages/shared-components/university-course-reviews/Pagination";

interface OpenDaysPaginationWrapperProps {
  totalPages: number;
  currentPageNo: number;
}

const OpenDaysPaginationWrapper = ({
  totalPages,
  currentPageNo,
}: OpenDaysPaginationWrapperProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const buildPageUrl = (page: number): string => {
    const params = new URLSearchParams(searchParams?.toString() || "");
    if (page === 1) {
      params.delete("pageno");
    } else {
      params.set("pageno", String(page));
    }

    const queryString = params.toString();
    return queryString
      ? `/open-days/search/?${queryString}`
      : "/open-days/";
  };

  const handlePageChange = (page: number) => {
    if (page === currentPageNo) return;

    const url = buildPageUrl(page);
    router.push(url);

    // Scroll to top of results
    const resultsSection = document.getElementById("srpageBodySection");
    if (resultsSection) {
      resultsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Pagination
      totalPages={totalPages}
      currentPageNo={currentPageNo}
      onChange={handlePageChange}
      buildPageUrl={buildPageUrl}
    />
  );
};

export default OpenDaysPaginationWrapper;
